import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./components/HomePage";
import AdminLogin from "./components/AdminLogin";
import AdminDashboard from "./components/AdminDashboard";
import { SiteProvider } from "./lib/siteContext";
import { CustomerProvider } from "./lib/customerContext";

function App() {
  return (
    <div className="App">
      <SiteProvider>
        <CustomerProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/admin/login" element={<AdminLogin />} />
            </Routes>
          </BrowserRouter>
        </CustomerProvider>
      </SiteProvider>
    </div>
  );
}

export default App;
